const PlaceTypeEnvironment = () => import('@/views/modules/place/TypeEnvironment')
const PlaceTypeEnvironmentForm = () => import('@/views/modules/place/TypeEnvironmentForm')
const PlaceEnterprise = () => import('@/views/modules/place/Enterprise')
const PlaceEnterpriseForm = () => import('@/views/modules/place/EnterpriseForm')
const PlaceWork = () => import('@/views/modules/place/Work')
const PlaceWorkForm = () => import('@/views/modules/place/WorkForm')
const PlaceEnvironment = () => import('@/views/modules/place/EnvironmentDESABILITADO')
const PlaceEnvironmentForm = () => import('@/views/modules/place/EnvironmentFormDESABILITADO')
const PlaceSpotDetail = () => import('@/views/modules/place/SpotDetail')
const PlaceSpotDetailForm = () => import('@/views/modules/place/SpotDetailForm')
const PlaceSpotSpecification = () => import('@/views/modules/place/SpotSpecification')
const PlaceSpotSpecificationForm = () => import('@/views/modules/place/SpotSpecificationForm')
const PlaceTypeEnterprise = () => import('@/views/modules/place/TypeEnterprise')
const PlaceTypeEnterpriseForm = () => import('@/views/modules/place/TypeEnterpriseForm')
const PlaceTypeSpotDetail = () => import('@/views/modules/place/TypeSpotDetail')
const PlaceTypeSpotDetailForm = () => import('@/views/modules/place/TypeSpotDetailForm')
const PlaceTypeSpotFolder = () => import('@/views/modules/place/TypeSpotFolder')
const PlaceTypeSpotFolderForm = () => import('@/views/modules/place/TypeSpotFolderForm')
const PlaceSettingParam = () => import('@/views/modules/place/Setting/SettingParam')
const PlaceSettingParamForm = () => import('@/views/modules/place/Setting/SettingParamForm')
const PlaceSetting = () => import('@/views/modules/place/Setting/Setting')
const PlaceReport = () => import('@/views/modules/place/Report/PlaceReport')

const ChecklistChecklist = () => import('@/views/modules/checklist/Checklist/Checklist')
const ChecklistChecklistForm = () => import('@/views/modules/checklist/Checklist/ChecklistForm')
const ChecklistSchedule = () => import('@/views/modules/checklist/Schedule')
const ChecklistScheduleForm = () => import('@/views/modules/checklist/ScheduleForm')
const ChecklistOccurrence = () => import('@/views/modules/checklist/Occurrence')
const ChecklistOccurrenceForm = () => import('@/views/modules/checklist/OccurrenceForm')
const ChecklistTypeChecklistModel = () => import('@/views/modules/checklist/TypeChecklistModel')
const ChecklistTypeChecklistModelForm = () => import('@/views/modules/checklist/TypeChecklistModelForm')
const ChecklistTypeChecklistItem = () => import('@/views/modules/checklist/TypeChecklistItem')
const ChecklistTypeChecklistItemForm = () => import('@/views/modules/checklist/TypeChecklistItemForm')
const ChecklistTypeOperationStatus = () => import('@/views/modules/checklist/TypeChecklistStatus')
const ChecklistTypeOperationStatusForm = () => import('@/views/modules/checklist/TypeChecklistStatusForm')
const ChecklistTypeOccurrenceStatus = () => import('@/views/modules/checklist/TypeOccurrenceStatus')
const ChecklistTypeOccurrenceStatusForm = () => import('@/views/modules/checklist/TypeOccurrenceStatusForm')
const ChecklistTypePathology = () => import('@/views/modules/checklist/TypePathology')
const ChecklistTypePathologyForm = () => import('@/views/modules/checklist/TypePathologyForm')
const ChecklistTypeCriticality = () => import('@/views/modules/checklist/TypeCriticality')
const ChecklistTypeCriticalityForm = () => import('@/views/modules/checklist/TypeCriticalityForm')
const ChecklistActivity1 = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity1')
const ChecklistActivity1Form = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity1Form')
const ChecklistActivity2 = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity2')
const ChecklistActivity2Form = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity2Form')
const ChecklistActivity3 = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity3')
const ChecklistActivity3Form = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity3Form')
const ChecklistActivity4 = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity4')
const ChecklistActivity4Form = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity4Form')
const ChecklistActivity5 = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity5')
const ChecklistActivity5Form = () => import('@/views/modules/checklist/ChecklistActivity/ChecklistActivity5Form')
const ChecklistTypeActivity = () => import('@/views/modules/checklist/TypeActivity')
const ChecklistTypeEvidenceService = () => import('@/views/modules/checklist/TypeEvidenceService')
const ChecklistTypeEvidenceServiceForm = () => import('@/views/modules/checklist/TypeEvidenceServiceForm')
const ChecklistTypeEvidenceCategory = () => import('@/views/modules/checklist/TypeEvidenceCategory')
const ChecklistTypeEvidenceCategoryForm = () => import('@/views/modules/checklist/TypeEvidenceCategoryForm')
const ChecklistTypeEvidenceStatus = () => import('@/views/modules/checklist/TypeEvidenceStatus')
const ChecklistTypeEvidenceStatusForm = () => import('@/views/modules/checklist/TypeEvidenceStatusForm')
const ChecklistTypeNotInspected = () => import('@/views/modules/checklist/TypeNotInspected')
const ChecklistTypeNotInspectedForm = () => import('@/views/modules/checklist/TypeNotInspectedForm')
const ChecklistSettingParam = () => import('@/views/modules/checklist/Setting/SettingParam')
const ChecklistSettingParamForm = () => import('@/views/modules/checklist/Setting/SettingParamForm')
const ChecklistTypeRegulation = () => import('@/views/modules/checklist/TypeRegulation')
const ChecklistTypeRegulationForm = () => import('@/views/modules/checklist/TypeRegulationForm')

const ChecklistTypeEstateItemStatus = () => import('@/views/modules/checklist/TypeEstateItemStatus')
const ChecklistTypeEstateItemStatusForm = () => import('@/views/modules/checklist/TypeEstateItemStatusForm')

const ChecklistTypeChecklistItemCategory = () => import('@/views/modules/checklist/TypeChecklistItemCategory')
const ChecklistTypeChecklistItemCategoryForm = () => import('@/views/modules/checklist/TypeChecklistItemCategoryForm')
const ChecklistRegulation = () => import('@/views/modules/checklist/Regulation')
const ChecklistRegulationForm = () => import('@/views/modules/checklist/RegulationForm')
const ChecklistSetting = () => import('@/views/modules/checklist/Setting/Setting')
const ChecklistReport = () => import('@/views/modules/checklist/Report/ChecklistReport')


const AgentSector = () => import('@/views/modules/agent/TypeSector')
const AgentSectorForm = () => import('@/views/modules/agent/TypeSectorForm')
const AgentExecutor = () => import('@/views/modules/agent/Executor')
const AgentExecutorForm = () => import('@/views/modules/agent/ExecutorForm')
const AgentInspector = () => import('@/views/modules/agent/Inspector')
const AgentInspectorForm = () => import('@/views/modules/agent/InspectorForm')
const AgentSettingParam = () => import('@/views/modules/agent/Setting/SettingParam')
const AgentSettingParamForm = () => import('@/views/modules/agent/Setting/SettingParamForm')
const AgentSetting = () => import('@/views/modules/agent/Setting/Setting')

export default [

    {
        path: '/checklist/type-model/new',
        name: 'checklist-type-model-form-new',
        component: ChecklistTypeChecklistModelForm
    }, {
        path: '/checklist/type-model/view/:id',
        name: 'checklist-type-model-form-view',
        component: ChecklistTypeChecklistModelForm
    }, {
        path: '/checklist/type-model/remove/:id',
        name: 'checklist-type-model-form-remove',
        component: ChecklistTypeChecklistModelForm
    }, {
        path: '/checklist/type-model/:id',
        name: 'checklist-type-model-form',
        component: ChecklistTypeChecklistModelForm
    }, {path: '/checklist/type-model', name: 'checklist-type-model', component: ChecklistTypeChecklistModel}

    , {
        path: '/checklist/type-operation-status/new',
        name: 'checklist-type-operation-status-form-new',
        component: ChecklistTypeOperationStatusForm
    }, {
        path: '/checklist/type-operation-status/view/:id',
        name: 'checklist-type-operation-status-view',
        component: ChecklistTypeOperationStatusForm
    }, {
        path: '/checklist/type-operation-status/remove/:id',
        name: 'checklist-type-operation-status-remove',
        component: ChecklistTypeOperationStatusForm
    }, {
        path: '/checklist/type-operation-status/:id',
        name: 'checklist-type-operation-status-form',
        component: ChecklistTypeOperationStatusForm
    }
    , {
        path: '/checklist/type-operation-status',
        name: 'checklist-type-operation-status',
        component: ChecklistTypeOperationStatus
    }
    , {
        path: '/checklist/type-occurrence-status/new',
        name: 'checklist-type-occurrence-status-form-new',
        component: ChecklistTypeOccurrenceStatusForm
    }, {
        path: '/checklist/type-occurrence-status/view/:id',
        name: 'checklist-type-occurrence-status-form-view',
        component: ChecklistTypeOccurrenceStatusForm
    }, {
        path: '/checklist/type-occurrence-status/remove/:id',
        name: 'checklist-type-occurrence-status-form-remove',
        component: ChecklistTypeOccurrenceStatusForm
    }, {
        path: '/checklist/type-occurrence-status/:id',
        name: 'checklist-type-occurrence-status-form',
        component: ChecklistTypeOccurrenceStatusForm
    }
    , {
        path: '/checklist/type-occurrence-status',
        name: 'checklist-type-occurrence-status',
        component: ChecklistTypeOccurrenceStatus
    }, {
        path: '/checklist/schedule/new',
        name: 'checklist-schedule-form-new',
        component: ChecklistScheduleForm
    }, {
        path: '/checklist/schedule/view/:id',
        name: 'checklist-schedule-form-view',
        component: ChecklistScheduleForm
    }, {
        path: '/checklist/schedule/remove/:id',
        name: 'checklist-schedule-form-remove',
        component: ChecklistScheduleForm
    }, {
        path: '/checklist/schedule/:id',
        name: 'checklist-schedule-form',
        component: ChecklistScheduleForm
    }
    , {path: '/checklist/schedule', name: 'checklist-schedule', component: ChecklistSchedule},

    {
        path: '/checklist/occurrence/new',
        name: 'checklist-occurrence-form-new',
        component: ChecklistOccurrenceForm
    }, {
        path: '/checklist/occurrence/view/:id',
        name: 'checklist-occurrence-form-view',
        component: ChecklistOccurrenceForm
    }, {
        path: '/checklist/occurrence/remove/:id',
        name: 'checklist-occurrence-form-remove',
        component: ChecklistOccurrenceForm
    }, {
        path: '/checklist/occurrence/:id',
        name: 'checklist-occurrence-form',
        component: ChecklistOccurrenceForm
    }
    , {path: '/checklist/occurrence', name: 'checklist-occurrence', component: ChecklistOccurrence},

    {
        path: '/place/type-environment/new',
        name: 'place-type-environment-form-new',
        component: PlaceTypeEnvironmentForm
    }, {
        path: '/place/type-environment/view/:id',
        name: 'place-type-environment-form-view',
        component: PlaceTypeEnvironmentForm
    }, {
        path: '/place/type-environment/remove/:id',
        name: 'place-type-environment-form-remove',
        component: PlaceTypeEnvironmentForm
    }, {
        path: '/place/type-environment/:id',
        name: 'place-type-environment-form',
        component: PlaceTypeEnvironmentForm
    }
    , {path: '/place/type-environment', name: 'place-type-environment', component: PlaceTypeEnvironment}


    , {
        path: '/checklist/type-item/new',
        name: 'checklist-type-item-form-new',
        component: ChecklistTypeChecklistItemForm
    }, {
        path: '/checklist/type-item/view/:id',
        name: 'checklist-type-item-form-view',
        component: ChecklistTypeChecklistItemForm
    }, {
        path: '/checklist/type-item/remove/:id',
        name: 'checklist-type-item-form-remove',
        component: ChecklistTypeChecklistItemForm
    }, {
        path: '/checklist/type-item/:id',
        name: 'checklist-type-item-form',
        component: ChecklistTypeChecklistItemForm
    }
    , {path: '/checklist/type-item', name: 'checklist-type-item', component: ChecklistTypeChecklistItem}

    , {
        path: '/checklist/type-item-category/new',
        name: 'checklist-type-item-category-form-new',
        component: ChecklistTypeChecklistItemCategoryForm
    }, {
        path: '/checklist/type-item-category/view/:id',
        name: 'checklist-type-item-category-form-view',
        component: ChecklistTypeChecklistItemCategoryForm
    }, {
        path: '/checklist/type-item-category/remove/:id',
        name: 'checklist-type-item-category-form-remove',
        component: ChecklistTypeChecklistItemCategoryForm
    }, {
        path: '/checklist/type-item-category/:id',
        name: 'checklist-type-item-category-form',
        component: ChecklistTypeChecklistItemCategoryForm
    }
    , {path: '/checklist/type-item-category', name: 'checklist-type-item-category', component: ChecklistTypeChecklistItemCategory}

    , {
        path: '/checklist/type-estate-item-status/new',
        name: 'checklist-type-estate-item-status-form-new',
        component: ChecklistTypeEstateItemStatusForm
    }, {
        path: '/checklist/type-estate-item-status/view/:id',
        name: 'checklist-type-estate-item-status-form-view',
        component: ChecklistTypeEstateItemStatusForm
    }, {
        path: '/checklist/type-estate-item-status/remove/:id',
        name: 'checklist-type-estate-item-status-form-remove',
        component: ChecklistTypeEstateItemStatusForm
    }, {
        path: 'checklist/type-estate-item-status/:id',
        name: 'checklist-type-estate-item-status-form',
        component: ChecklistTypeEstateItemStatusForm
    }
    , {path: '/checklist/type-estate-item-status', name: 'checklist-type-estate-item-status', component: ChecklistTypeEstateItemStatus}


    , {
        path: '/checklist/type-regulation/new',
        name: 'checklist-type-regulation-form-new',
        component: ChecklistTypeRegulationForm
    }, {
        path: '/checklist/type-regulation/view/:id',
        name: 'checklist-type-regulation-form-view',
        component: ChecklistTypeRegulationForm
    }, {
        path: '/checklist/type-regulation/remove/:id',
        name: 'checklist-type-regulation-form-remove',
        component: ChecklistTypeRegulationForm
    }, {
        path: '/checklist/type-regulation/:id',
        name: 'checklist-type-regulation-form',
        component: ChecklistTypeRegulationForm
    }
    , {path: '/checklist/type-regulation', name: 'checklist-type-regulation', component: ChecklistTypeRegulation}



    , {
        path: '/checklist/regulation/new',
        name: 'checklist-regulation-form-new',
        component: ChecklistRegulationForm
    }, {
        path: '/checklist/regulation/view/:id',
        name: 'checklist-regulation-form-view',
        component: ChecklistRegulationForm
    }, {
        path: '/checklist/regulation/remove/:id',
        name: 'checklist-regulation-form-remove',
        component: ChecklistRegulationForm
    }, {
        path: '/checklist/regulation/:id',
        name: 'checklist-regulation-form',
        component: ChecklistRegulationForm
    }
    , {path: '/checklist/regulation', name: 'checklist-regulation', component: ChecklistRegulation}

    , {
        path: '/checklist/type-pathology/new',
        name: 'checklist-type-pathology-form-new',
        component: ChecklistTypePathologyForm
    }, {
        path: '/checklist/type-pathology/view/:id',
        name: 'checklist-type-pathology-form-view',
        component: ChecklistTypePathologyForm
    }, {
        path: '/checklist/type-pathology/remove/:id',
        name: 'checklist-type-pathology-form-remove',
        component: ChecklistTypePathologyForm
    }, {
        path: '/checklist/type-pathology/:id',
        name: 'checklist-type-pathology-form',
        component: ChecklistTypePathologyForm
    }
    , {path: '/checklist/type-pathology', name: 'checklist-type-pathology', component: ChecklistTypePathology}


    , {
        path: '/checklist/type-criticality/new',
        name: 'checklist-type-criticality-form-new',
        component: ChecklistTypeCriticalityForm
    }, {
        path: '/checklist/type-criticality/view/:id',
        name: 'checklist-type-criticality-form-view',
        component: ChecklistTypeCriticalityForm
    }, {
        path: '/checklist/type-criticality/remove/:id',
        name: 'checklist-type-criticality-form-remove',
        component: ChecklistTypeCriticalityForm
    }, {
        path: '/checklist/type-criticality/:id',
        name: 'checklist-type-criticality-form',
        component: ChecklistTypeCriticalityForm
    }
    , {path: '/checklist/type-criticality', name: 'checklist-type-criticality', component: ChecklistTypeCriticality}

    , {
        path: '/checklist/activity1/new',
        name: 'checklist-executed-activity1-form-new',
        component: ChecklistActivity1Form
    }, {
        path: '/checklist/activity1/view/:id',
        name: 'checklist-executed-activity1-form-view',
        component: ChecklistActivity1Form
    }, {
        path: '/checklist/activity1/remove/:id',
        name: 'checklist-executed-activity1-form-remove',
        component: ChecklistActivity1Form
    }, {
        path: '/checklist/activity1/:id',
        name: 'checklist-executed-activity1-form',
        component: ChecklistActivity1Form
    }
    , {path: '/checklist/activity1', name: 'checklist-executed-activity1', component: ChecklistActivity1}

    , {
        path: '/checklist/activity2/new',
        name: 'checklist-executed-activity2-form-new',
        component: ChecklistActivity2Form
    }, {
        path: '/checklist/activity2/view/:id',
        name: 'checklist-executed-activity2-form-view',
        component: ChecklistActivity2Form
    }, {
        path: '/checklist/activity2/remove/:id',
        name: 'checklist-executed-activity2-form-remove',
        component: ChecklistActivity2Form
    }, {
        path: '/checklist/activity2/:id',
        name: 'checklist-executed-activity2-form',
        component: ChecklistActivity2Form
    }
    , {path: '/checklist/activity2', name: 'checklist-executed-activity2', component: ChecklistActivity2}

    , {
        path: '/checklist/activity3/new',
        name: 'checklist-executed-activity3-form-new',
        component: ChecklistActivity3Form
    }, {
        path: '/checklist/activity3/view/:id',
        name: 'checklist-executed-activity3-form-view',
        component: ChecklistActivity3Form
    }, {
        path: '/checklist/activity3/remove/:id',
        name: 'checklist-executed-activity3-form-remove',
        component: ChecklistActivity3Form
    }, {
        path: '/checklist/activity3/:id',
        name: 'checklist-executed-activity3-form',
        component: ChecklistActivity3Form
    }
    , {path: '/checklist/activity3', name: 'checklist-executed-activity3', component: ChecklistActivity3}

    , {
        path: '/checklist/activity4/new',
        name: 'checklist-executed-activity4-form-new',
        component: ChecklistActivity4Form
    }, {
        path: '/checklist/activity4/view/:id',
        name: 'checklist-executed-activity4-form-view',
        component: ChecklistActivity4Form
    }, {
        path: '/checklist/activity4/remove/:id',
        name: 'checklist-executed-activity4-form-remove',
        component: ChecklistActivity4Form
    }, {
        path: '/checklist/activity4/:id',
        name: 'checklist-executed-activity4-form',
        component: ChecklistActivity4Form
    }
    , {path: '/checklist/activity4', name: 'checklist-executed-activity4', component: ChecklistActivity4}


    , {
        path: '/checklist/activity5/new',
        name: 'checklist-executed-activity5-form-new',
        component: ChecklistActivity5Form
    }, {
        path: '/checklist/activity5/view/:id',
        name: 'checklist-executed-activity5-form-view',
        component: ChecklistActivity5Form
    }, {
        path: '/checklist/activity5/remove/:id',
        name: 'checklist-executed-activity5-form-remove',
        component: ChecklistActivity5Form
    }, {
        path: '/checklist/activity5/:id',
        name: 'checklist-executed-activity5-form',
        component: ChecklistActivity5Form
    }
    , {path: '/checklist/activity5', name: 'checklist-executed-activity5', component: ChecklistActivity5}

    , {path: '/checklist/type-activity', name: 'checklist-type-activity', component: ChecklistTypeActivity}

    , {
        path: '/checklist/type-evidence-status/new',
        name: 'checklist-type-evidence-status-form-new',
        component: ChecklistTypeEvidenceStatusForm
    }, {
        path: '/checklist/type-evidence-status/view/:id',
        name: 'checklist-type-evidence-status-form-view',
        component: ChecklistTypeEvidenceStatusForm
    }, {
        path: '/checklist/type-evidence-status/remove/:id',
        name: 'checklist-type-evidence-status-form-remove',
        component: ChecklistTypeEvidenceStatusForm
    }, {
        path: '/checklist/type-evidence-status/:id',
        name: 'checklist-type-evidence-status-form',
        component: ChecklistTypeEvidenceStatusForm
    }
    , {
        path: '/checklist/type-evidence-status',
        name: 'checklist-type-evidence-status',
        component: ChecklistTypeEvidenceStatus
    }

    , {
        path: '/checklist/type-not-inspected/new',
        name: 'checklist-type-not-inspected-form-new',
        component: ChecklistTypeNotInspectedForm
    }, {
        path: '/checklist/type-not-inspected/view/:id',
        name: 'checklist-type-not-inspected-form-view',
        component: ChecklistTypeNotInspectedForm
    }, {
        path: '/checklist/type-not-inspected/remove/:id',
        name: 'checklist-type-not-inspected-form-remove',
        component: ChecklistTypeNotInspectedForm
    }, {
        path: '/checklist/type-not-inspected/:id',
        name: 'checklist-type-not-inspected-form',
        component: ChecklistTypeNotInspectedForm
    }
    , {
        path: '/checklist/type-not-inspected',
        name: 'checklist-type-not-inspected',
        component: ChecklistTypeNotInspected
    }

    , {
        path: '/checklist/type-evidence-service/new',
        name: 'checklist-type-evidence-service-form-new',
        component: ChecklistTypeEvidenceServiceForm
    }, {
        path: '/checklist/type-evidence-service/view/:id',
        name: 'checklist-type-evidence-service-form-view',
        component: ChecklistTypeEvidenceServiceForm
    }, {
        path: '/checklist/type-evidence-service/remove/:id',
        name: 'checklist-type-evidence-service-form-remove',
        component: ChecklistTypeEvidenceServiceForm
    }, {
        path: '/checklist/type-evidence-service/:id',
        name: 'checklist-type-evidence-service-form',
        component: ChecklistTypeEvidenceServiceForm
    }
    , {
        path: '/checklist/type-evidence-service',
        name: 'checklist-type-evidence-service',
        component: ChecklistTypeEvidenceService
    }

    , {
        path: '/checklist/type-evidence-category/new',
        name: 'checklist-type-evidence-category-form-new',
        component: ChecklistTypeEvidenceCategoryForm
    }, {
        path: '/checklist/type-evidence-category/view/:id',
        name: 'checklist-type-evidence-category-form-view',
        component: ChecklistTypeEvidenceCategoryForm
    }, {
        path: '/checklist/type-evidence-category/remove/:id',
        name: 'checklist-type-evidence-category-form-remove',
        component: ChecklistTypeEvidenceCategoryForm
    }, {
        path: '/checklist/type-evidence-category/:id',
        name: 'checklist-type-evidence-category-form',
        component: ChecklistTypeEvidenceCategoryForm
    }
    , {
        path: '/checklist/type-evidence-category',
        name: 'checklist-type-evidence-category',
        component: ChecklistTypeEvidenceCategory
    }


    , {
        path: '/checklist/setting/param/view/:id',
        name: 'checklist-setting-param-form-view',
        component: ChecklistSettingParamForm
    }, {
        path: '/checklist/setting/param/:id',
        name: 'checklist-setting-param-form-',
        component: ChecklistSettingParamForm
    }

    , {path: '/checklist/setting/param', name: 'checklist-setting-param', component: ChecklistSettingParam}

    , {path: '/checklist/setting', name: 'checklist-setting', component: ChecklistSetting}

    , {path: '/checklist/report', name: 'checklist-report', component: ChecklistReport}


    /*ÚLTIMO DEVIDO PATH CURTO*/
    , {
        path: '/checklist/view/:id',
        name: 'checklist-executed-form-view',
        component: ChecklistChecklistForm
    }, {
        path: '/checklist/remove/:id',
        name: 'checklist-executed-form-remove',
        component: ChecklistChecklistForm
    }, {
        path: '/checklist/:id',
        name: 'checklist-executed-form',
        component: ChecklistChecklistForm
    }
    , {path: '/checklist', name: 'checklist-executed', component: ChecklistChecklist}

    /*---------------------------------------------------------*/


    , {
        path: '/agent/type-sector/new',
        name: 'agent-type-sector-form-new',
        component: AgentSectorForm
    }, {
        path: '/agent/type-sector/view/:id',
        name: 'agent-type-sector-form-view',
        component: AgentSectorForm
    }, {
        path: '/agent/type-sector/remove/:id',
        name: 'agent-type-sector-form-remove',
        component: AgentSectorForm
    }, {
        path: '/agent/type-sector/:id',
        name: 'agent-type-sector-form',
        component: AgentSectorForm
    }
    , {path: '/agent/type-sector', name: 'agent-type-sector', component: AgentSector}


    , {
        path: '/agent/executor/new',
        name: 'agent-executor-form-new',
        component: AgentExecutorForm
    }, {
        path: '/agent/executor/view/:id',
        name: 'agent-executor-form-view',
        component: AgentExecutorForm
    }, {
        path: '/agent/executor/remove/:id',
        name: 'agent-executor-form-remove',
        component: AgentExecutorForm
    }, {
        path: '/agent/executor/:id',
        name: 'agent-executor-form',
        component: AgentExecutorForm
    }
    , {path: '/agent/executor', name: 'agent-executor', component: AgentExecutor}


    , {
        path: '/agent/inspector/new',
        name: 'agent-inspector-form-new',
        component: AgentInspectorForm
    }, {
        path: '/agent/inspector/view/:id',
        name: 'agent-inspector-form-view',
        component: AgentInspectorForm
    }, {
        path: '/agent/inspector/remove/:id',
        name: 'agent-inspector-form-remove',
        component: AgentInspectorForm
    }, {
        path: '/agent/inspector/:id',
        name: 'agent-inspector-form',
        component: AgentInspectorForm
    }
    , {path: '/agent/inspector', name: 'agent-inspector', component: AgentInspector}

    , {
        path: '/agent/setting/param/view/:id',
        name: 'agent-setting-param-form-view',
        component: AgentSettingParamForm
    }, {
        path: '/agent/setting/param/:id', name: 'agent-setting-param-form-', component: AgentSettingParamForm
    }

    , {path: '/agent/setting/param', name: 'agent-setting-param', component: AgentSettingParam}


    , {path: '/agent/setting', name: 'agent-setting', component: AgentSetting}


    , {
        path: '/place/enterprise/new',
        name: 'place-enterprise-form-new',
        component: PlaceEnterpriseForm
    }, {
        path: '/place/enterprise/view/:id',
        name: 'place-enterprise-form-view',
        component: PlaceEnterpriseForm
    }, {
        path: '/place/enterprise/remove/:id',
        name: 'place-enterprise-form-remove',
        component: PlaceEnterpriseForm
    }, {
        path: '/place/enterprise/:id',
        name: 'place-enterprise-form',
        component: PlaceEnterpriseForm
    }
    , {path: '/place/enterprise', name: 'place-enterprise', component: PlaceEnterprise}

    , {
        path: '/place/work/new',
        name: 'place-work-form-new',
        component: PlaceWorkForm
    }, {
        path: '/place/work/view/:id',
        name: 'place-work-form-view',
        component: PlaceWorkForm
    }, {
        path: '/place/work/remove/:id',
        name: 'place-work-form-remove',
        component: PlaceWorkForm
    }, {
        path: '/place/work/:id',
        name: 'place-work-form',
        component: PlaceWorkForm
    }
    , {path: '/place/work', name: 'place-work', component: PlaceWork}


    , {path: '/place/report', name: 'place-report', component: PlaceReport}

    , {
        path: '/place/environment/new',
        name: 'place-environment-form-new',
        component: PlaceEnvironmentForm
    }, {
        path: '/place/environment/view/:id',
        name: 'place-environment-form-view',
        component: PlaceEnvironmentForm
    }, {
        path: '/place/environment/remove/:id',
        name: 'place-environment-form-remove',
        component: PlaceEnvironmentForm
    }, {
        path: '/place/environment/:id',
        name: 'place-environment-form',
        component: PlaceEnvironmentForm
    }
    , {path: '/place/environment', name: 'place-environment', component: PlaceEnvironment}


    , {
        path: '/place/spot-detail/new',
        name: 'place-spot-detail-form-new',
        component: PlaceSpotDetailForm
    }, {
        path: '/place/spot-detail/view/:id',
        name: 'place-spot-detail-form-view',
        component: PlaceSpotDetailForm
    }, {
        path: '/place/spot-detail/remove/:id',
        name: 'place-spot-detail-form-remove',
        component: PlaceSpotDetailForm
    }, {
        path: '/place/spot-detail/:id',
        name: 'place-spot-detail-form',
        component: PlaceSpotDetailForm
    }
    , {path: '/place/spot-detail', name: 'place-spot-detail', component: PlaceSpotDetail}


    , {
        path: '/place/spot-specification/new',
        name: 'place-spot-specification-form-new',
        component: PlaceSpotSpecificationForm
    }, {
        path: '/place/spot-specification/view/:id',
        name: 'place-spot-specification-form-view',
        component: PlaceSpotSpecificationForm
    }, {
        path: '/place/spot-specification/remove/:id',
        name: 'place-spot-specification-form-remove',
        component: PlaceSpotSpecificationForm
    }, {
        path: '/place/spot-specification/:id',
        name: 'place-spot-specification-form',
        component: PlaceSpotSpecificationForm
    }
    , {path: '/place/spot-specification', name: 'place-spot-specification', component: PlaceSpotSpecification}


    , {
        path: '/place/type-enterprise/new',
        name: 'place-type-enterprise-form-new',
        component: PlaceTypeEnterpriseForm
    }, {
        path: '/place/type-enterprise/view/:id',
        name: 'place-type-enterprise-form-view',
        component: PlaceTypeEnterpriseForm
    }, {
        path: '/place/type-enterprise/remove/:id',
        name: 'place-type-enterprise-form-remove',
        component: PlaceTypeEnterpriseForm
    }, {
        path: '/place/type-enterprise/:id',
        name: 'place-type-enterprise-form',
        component: PlaceTypeEnterpriseForm
    }
    , {path: '/place/type-enterprise', name: 'place-type-enterprise', component: PlaceTypeEnterprise}


    , {
        path: '/place/type-spot-detail/new',
        name: 'place-type-spot-detail-form-new',
        component: PlaceTypeSpotDetailForm
    }, {
        path: '/place/type-spot-detail/view/:id',
        name: 'place-type-spot-detail-form-view',
        component: PlaceTypeSpotDetailForm
    }, {
        path: '/place/type-spot-detail/remove/:id',
        name: 'place-type-spot-detail-form-remove',
        component: PlaceTypeSpotDetailForm
    }, {
        path: '/place/type-spot-detail/:id',
        name: 'place-type-spot-detail-form',
        component: PlaceTypeSpotDetailForm
    }
    , {path: '/place/type-spot-detail', name: 'place-type-spot-detail', component: PlaceTypeSpotDetail},

    {
        path: '/place/type-spot-folder/new',
        name: 'place-type-spot-folder-form-new',
        component: PlaceTypeSpotFolderForm
    }, {
        path: '/place/type-spot-folder/view/:id',
        name: 'place-type-spot-folder-form-view',
        component: PlaceTypeSpotFolderForm
    }, {
        path: '/place/type-spot-folder/remove/:id',
        name: 'place-type-spot-folder-form-remove',
        component: PlaceTypeSpotFolderForm
    }, {
        path: '/place/type-spot-folder/:id',
        name: 'place-type-spot-folder-form',
        component: PlaceTypeSpotFolderForm
    }
    , {path: '/place/type-spot-folder', name: 'place-type-spot-folder', component: PlaceTypeSpotFolder},

    {
        path: '/place/setting/param/view/:id',
        name: 'place-setting-param-form-view',
        component: PlaceSettingParamForm
    }, {
        path: '/place/setting/param/:id', name: 'place-setting-param-form-', component: PlaceSettingParamForm
    }

    , {path: '/place/setting/param', name: 'place-setting-param', component: PlaceSettingParam}


    , {path: '/place/setting', name: 'place-setting', component: PlaceSetting}

]